<template>
  <section class="flex flex-wrap flex-col gap-1">
    <span class="flex gap-1 items-center leading-tight flex-wrap">
      <span>{{ $t(`${trPrefix}from`) }}</span>
      <span class="font-semibold text-xl"> {{ perNight }} / </span>
      <span>{{ $t(`${trPrefix}night`) }}</span>
    </span>

    <span class="flex gap-2 items-center leading-tight flex-wrap">
      <span v-if="hasDiscount" class="text-hlt-hover line-through">
        {{ orig }}
      </span>
      <span>{{ current }} {{ $t(`${trPrefix}total`).toLowerCase() }}</span>

      <RedesignAccomCardPriceLegalInfo />
    </span>
  </section>
</template>

<script setup lang="ts">
const trPrefix = 'www.components.hitbox.Price.'

const props = defineProps<{
  trip: Trip
  currency: string
}>()

const { toMoney } = useMoneyFormat(() => props.currency)

const hasDiscount = computed(() => !!props.trip.reduction)
const orig = computed(() => toMoney(getTripOrigPrice(props.trip)))
const current = computed(() => toMoney(props.trip.price))
const perNight = computed(() => toMoney(props.trip.pricePerNight ?? 0))
</script>
